import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Query, QueryClient ,QueryClientProvider } from '@tanstack/react-query'
const root = ReactDOM.createRoot(document.getElementById('root'));
const queryClient = new QueryClient()

const REACT_GOOGLE_CLIENT_RF_ID=process.env.REACT_APP_GOOGLE_CLIENT_RF_ID
console.log(process.env.REACT_APP_GOOGLE_CLIENT_RF_ID,'REACT_GOOGLE_CLIENT_RF_ID')
root.render(
<GoogleOAuthProvider clientId={REACT_GOOGLE_CLIENT_RF_ID}>
    <QueryClientProvider client={queryClient}>
    <App />
    <ReactQueryDevtools initialIsOpen={false} buttonPosition='bottom-right' />
    </QueryClientProvider>
    </GoogleOAuthProvider>
 
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
